import { GoogleMap } from 'components/Map';

function App(): JSX.Element {
  return <GoogleMap />;
}

export default App;
